import strings from 'mobile_web/strings'
import { FC } from 'react'
import { Button, Card, CardContent, CardHeader } from '@mytours/components'
import Modal from '../../common/components/modal'

interface Props {
	onCloseSuccessModal: () => void
}

const SuccessModal: FC<Props> = ({ onCloseSuccessModal }) => {
	return (
		<Modal isOpen={true} backdropDismiss={false} cssClass="success-modal">
			<Card variant="ios">
				<CardHeader>
					<Button variant="clear" className="close" onClick={onCloseSuccessModal} aria-label={strings.close}>
						<i className="fal fa-xmark" />
					</Button>
				</CardHeader>
				<CardContent className="success-modal-content">
					<h1>{strings.purchase_successful}</h1>
					<p>{strings.purchase_successful_description}</p>

					<Button
						variant="primary"
						fill="var(--button-action-bg)"
						textColor="var(--title-color)"
						aria-label={strings.purchase_successful_continue}
						className="-submit"
						onClick={onCloseSuccessModal}
					>
						<p>{strings.purchase_successful_continue}</p>
					</Button>
				</CardContent>
			</Card>
		</Modal>
	)
}

export default SuccessModal
